<template>
  <div
    :class="`owal scroll container ${this.direction} ${bounce ? 'touch' : ''}`"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'OwalScrollContainer',
  /**
   * @prop {String} direction Controls the axes to enable scrolling on. 'horizontal' 'vertical' or 'both'
   * @prop {Boolean} bounce Enable bouncy scrolling on iOS.
   */
  props: {
    direction: {
      type: String,
      default: 'both',
      validation: function (newValue) {
        const validValues = ['horizontal', 'vertical', 'both']
        const valid = validValues.includes(newValue)

        if (!valid) {
          console.warn(`OwalScrollContainer.vue: Valid values are ${validValues.join(',')}`)
        }

        return valid
      },
    },
    bounce: {
      type: Boolean,
      default: true,
    },
  },
}
</script>

<style scoped>

/* Scrolls on both axes. */
.owal.scroll.container.both {
  overflow: auto;
}

/* Scrolls on the X axis, but clips on the Y axis. */
.owal.scroll.container.horizontal {
  overflow-y: hidden;
  overflow-x: auto;
}

/* Scrolls on the Y axis, but clips on the X axis. */
.owal.scroll.container.vertical {
  overflow-y: auto;
  overflow-x: hidden;
}

/* Bouncy scrolling on iOS. */
.owal.owal.scroll.container.both.touch,
.owal.owal.scroll.container.vertical.touch,
.owal.owal.scroll.container.horizontal.touch {
  -webkit-overflow-scrolling: touch;
}

</style>
